/* Nana, l'assistante GRENADINE, en fenetre plein ecran facon cuure.com.
   Reprend a l'identique les questions et la logique du diagnostic en ligne
   (/pages/votre-diagnostic). Ouverture : window.GrenadineNana.open({ firstMessage, prenom }). */
(function () {
  if (window.GrenadineNana) return;

  function esc(t) {
    return String(t).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function buildModal() {
    var m = document.createElement("div");
    m.className = "nana-modal";
    m.setAttribute("role", "dialog");
    m.setAttribute("aria-modal", "true");
    m.innerHTML =
      '<header class="nana-head">' +
        '<span class="nana-avatar" aria-hidden="true"><img src="https://cdn.shopify.com/s/files/1/0729/3983/1631/files/coeur_grenadine_rose.png?v=1745434173&width=120" alt=""></span>' +
        '<div class="nana-head-text"><p class="nana-head-title">Trouvez votre soin</p>' +
        '<p class="nana-head-sub">Nana, votre assistante GRENADINE, vous aide à trouver la prestation adaptée à vos cheveux 🩷</p></div>' +
        '<button type="button" class="nana-close" aria-label="Fermer">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
      '</header>' +
      '<div class="nana-body"><div class="nana-chat"></div><div class="nana-options"></div></div>' +
      '<form class="nana-bar" autocomplete="off">' +
        '<input class="nana-input" type="text" placeholder="Posez votre question" aria-label="Posez votre question">' +
        '<button type="button" class="nana-mic" aria-label="Dicter">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5 11a7 7 0 0 0 14 0M12 18v3"/></svg>' +
        '</button>' +
        '<button type="submit" class="nana-send" aria-label="Envoyer">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M6 11l6-6 6 6"/></svg>' +
        '</button>' +
      '</form>';
    return m;
  }

  // ===== moteur du diagnostic (code d'origine, branche sur la fenetre) =====
  function runDiagnostic(els, opts, api) {

    var chat = els.chat;
    var inputArea = els.options;

    var state = {
      prenom: "",
      dejaVenue: "",
      typeCheveux: "",
      textureCheveux: "",
      envieTexture: null,
      abimes: "",
      frequence: "",
      objectif: "",
      routine: "",
      stress: "",
      dernierSoin: "",
      satisfaiteDerniereFois: ""
    };

    var currentStepIndex = 0;
    var steps = [];

    var lienSoinClassique = "https://www.grenadinehair.com/products/soin-classique-brushing";
    var lienSoinProfond   = "https://www.grenadinehair.com/products/soin-profond-brushing";
    var lienLissage       = "https://www.grenadinehair.com/products/lissage-classic-bae";
    var lienProgrammeFid  = "https://www.grenadinehair.com/pages/programme-de-fidelite-grenadine";
    var lienRegister      = "https://www.grenadinehair.com/account/register";
    var lienLogin         = "https://www.grenadinehair.com/account/login?error=login_required";

    function scrollToBottom() {
      chat.scrollTop = chat.scrollHeight;
    }

    function addMessage(text, sender) {
      var msg = document.createElement('div');
      msg.className = 'diag-message ' + (sender === 'user' ? 'diag-user' : 'diag-bot');
      msg.innerHTML = text;
      chat.appendChild(msg);
      scrollToBottom();
    }

    // bulle "en train d'écrire"
    function showTyping(duration, callback) {
      var typing = document.createElement('div');
      typing.className = 'diag-message diag-bot diag-typing';
      typing.innerHTML = '<span class="diag-typing-dot"></span><span class="diag-typing-dot"></span><span class="diag-typing-dot"></span>';
      chat.appendChild(typing);
      scrollToBottom();
      setTimeout(function() {
        if (typing.parentNode) typing.parentNode.removeChild(typing);
        if (callback) callback();
      }, duration || 800);
    }

    function setInput(node) {
      inputArea.innerHTML = '';
      inputArea.appendChild(node);
    }

    function nextStep() {
      if (currentStepIndex < steps.length) {
        var fn = steps[currentStepIndex];
        currentStepIndex++;
        setTimeout(fn, 400);
      } else {
        setTimeout(showResult, 500);
      }
    }

    // Étape 1 : prénom
    function stepPrenom() {
      showTyping(900, function() {
        addMessage("Bonjour, je suis <strong>Nana</strong> 🩷<br>Comment vous appelez-vous ?", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var input = document.createElement('input');
      input.type = 'text';
      input.placeholder = 'Entrez votre prénom';
      input.className = 'diag-text-input';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'diag-btn';
      btn.textContent = 'Valider';

      btn.addEventListener('click', function() {
        var value = (input.value || '').trim();
        if (!value) {
          input.focus();
          return;
        }
        state.prenom = value;
        addMessage(value, 'user');
        nextStep();
      });

      input.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          btn.click();
        }
      });

      wrapperInput.appendChild(input);
      wrapperInput.appendChild(btn);
      setInput(wrapperInput);
      input.focus();
    }

    // Étape 2 : déjà venue ou première fois
    function stepDejaVenue() {
      var name = state.prenom ? state.prenom.charAt(0).toUpperCase() + state.prenom.slice(1) : "Belle cliente";
      showTyping(900, function() {
        addMessage(name + ", est-ce votre première fois chez Grenadine ou êtes-vous déjà venue au salon ?", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var options = [
        { value: "premiere", label: "C’est ma première fois" },
        { value: "deja", label: "Je suis déjà venue" }
      ];

      options.forEach(function(opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'diag-btn';
        btn.textContent = opt.label;
        btn.addEventListener('click', function() {

          state.dejaVenue = opt.value;
          addMessage(opt.label, 'user');

          if (opt.value === "premiere") {
            showTyping(900, function() {
              addMessage("Trop bien, vous ne connaissiez pas encore 🩷<br>Bienvenue chez <strong>Grenadine</strong> !", "bot");
              showTyping(1100, function() {
                addMessage(
                  "Nous sommes un salon de coiffure spécialisé dans les <strong>soins</strong> et les <strong>lissages</strong>.<br>" +
                  "Notre objectif : coiffer et sublimer <strong>tous les types de cheveux</strong> — lisses, bouclés, fins, frisés, crépus…<br>" +
                  "Nous ne proposons pas de coloration ni de balayage, uniquement des prestations dédiées à la <strong>santé</strong>, la <strong>brillance</strong> et la <strong>vitalité</strong> de votre chevelure ✨",
                  "bot"
                );
                nextStep();
              });
            });
          } else {
            showTyping(900, function() {
              addMessage("Ah super, ravie de vous revoir 🩷", "bot");
              nextStep();
            });
          }
        });
        wrapperInput.appendChild(btn);
      });

      setInput(wrapperInput);
    }

    // Étape 3 : pour les clientes déjà venues – dernière prestation & satisfaction
    function stepDerniereFois() {
      if (state.dejaVenue !== "deja") {
        nextStep();
        return;
      }

      showTyping(800, function() {
        addMessage("Qu’est-ce que vous aviez fait la fois d’avant ?", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var optionsPresta = [
        { value: "classique", label: "Soin classique" },
        { value: "profond", label: "Soin profond" },
        { value: "lissage", label: "Lissage" },
        { value: "autre", label: "Autre / je ne sais plus" }
      ];

      function askSatisfaction() {
        showTyping(800, function() {
          addMessage("Et est-ce que vous aviez été satisfaite du soin ?", "bot");
        });

        var satWrapper = document.createElement('div');
        satWrapper.className = 'diag-input-row';

        var optionsSat = [
          { value: "oui", label: "Oui, très satisfaite" },
          { value: "non", label: "Pas complètement satisfaite" }
        ];

        optionsSat.forEach(function(opt) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'diag-btn';
          btn.textContent = opt.label;
          btn.addEventListener('click', function() {
            state.satisfaiteDerniereFois = opt.value;
            addMessage(opt.label, 'user');

            if (opt.value === "oui") {
              showTyping(800, function() {
                addMessage("Top, ça me fait plaisir 🩷 On va rester dans cette continuité en affinant encore plus pour vous.", "bot");
                nextStep();
              });
            } else {
              showTyping(800, function() {
                addMessage("Merci de me le dire, c’est important pour nous. On va ajuster pour que cette fois-ci ce soit vraiment parfait pour vous ✨", "bot");
                nextStep();
              });
            }
          });
          satWrapper.appendChild(btn);
        });

        setInput(satWrapper);
      }

      optionsPresta.forEach(function(opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'diag-btn';
        btn.textContent = opt.label;
        btn.addEventListener('click', function() {
          state.dernierSoin = opt.value;
          addMessage(opt.label, 'user');
          askSatisfaction();
        });
        wrapperInput.appendChild(btn);
      });

      setInput(wrapperInput);
    }

    // Étape 4 : nature du cheveu
    function stepTypeCheveux() {
      showTyping(900, function() {
        addMessage("Parlons d’abord de la nature de vos cheveux : ils sont plutôt…", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var options = [
        { value: "fins", label: "Fins" },
        { value: "normaux", label: "Normaux" },
        { value: "epais", label: "Épais" }
      ];

      options.forEach(function(opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'diag-btn';
        btn.textContent = opt.label;
        btn.addEventListener('click', function() {
          state.typeCheveux = opt.value;
          addMessage(opt.label, 'user');
          nextStep();
        });
        wrapperInput.appendChild(btn);
      });

      setInput(wrapperInput);
    }

    // Étape 5 : texture
    function stepTextureCheveux() {
      showTyping(800, function() {
        addMessage("Et au niveau de la texture, comment sont vos cheveux naturellement ?", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var options = [
        { value: "lisses", label: "Lisses" },
        { value: "boucles", label: "Bouclés" },
        { value: "frises", label: "Frisés" },
        { value: "afro", label: "Afro / très frisés" }
      ];

      options.forEach(function(opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'diag-btn';
        btn.textContent = opt.label;
        btn.addEventListener('click', function() {
          state.textureCheveux = opt.value;
          addMessage(opt.label, 'user');
          nextStep();
        });
        wrapperInput.appendChild(btn);
      });

      setInput(wrapperInput);
    }

    // Étape 6 : envie par rapport à la texture
    function stepEnvieTexture() {
      if (state.textureCheveux === "lisses" || !state.textureCheveux) {
        state.envieTexture = null;
        nextStep();
        return;
      }

      var desc = "vos cheveux texturés";
      if (state.textureCheveux === "boucles") desc = "vos cheveux bouclés";
      if (state.textureCheveux === "frises") desc = "vos cheveux frisés";
      if (state.textureCheveux === "afro") desc = "vos cheveux afro";

      showTyping(800, function() {
        addMessage("Et par rapport à " + desc + ", qu’est-ce que vous souhaitez ?", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var options = [
        { value: "garder", label: "Garder ma texture naturelle" },
        { value: "brushing", label: "Juste un brushing ponctuel" },
        { value: "lisser_durablement", label: "Les lisser durablement (lissage)" }
      ];

      options.forEach(function(opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'diag-btn';
        btn.textContent = opt.label;
        btn.addEventListener('click', function() {
          state.envieTexture = opt.value;
          addMessage(opt.label, 'user');
          nextStep();
        });
        wrapperInput.appendChild(btn);
      });

      setInput(wrapperInput);
    }

    // Étape 7 : cheveux abîmés ?
    function stepCheveuxAbimes() {
      showTyping(800, function() {
        addMessage("Vos cheveux sont-ils abîmés, secs ou cassants actuellement ?", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var options = [
        { value: "oui", label: "Oui, ils sont abîmés et secs" },
        { value: "non", label: "Non, pas spécialement abîmés" }
      ];

      options.forEach(function(opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'diag-btn';
        btn.textContent = opt.label;
        btn.addEventListener('click', function() {
          state.abimes = opt.value;
          addMessage(opt.label, 'user');
          nextStep();
        });
        wrapperInput.appendChild(btn);
      });

      setInput(wrapperInput);
    }

    // Étape 8 : fréquence salon
    function stepFrequence() {
      showTyping(800, function() {
        addMessage("En moyenne, à quelle fréquence venez-vous chez le coiffeur ?", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var options = [
        { value: "moins1", label: "Moins d’une fois par an" },
        { value: "1a3", label: "1 à 3 fois par an" },
        { value: "plus3", label: "Plus de 3 fois par an" }
      ];

      options.forEach(function(opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'diag-btn';
        btn.textContent = opt.label;
        btn.addEventListener('click', function() {
          state.frequence = opt.value;
          addMessage(opt.label, 'user');
          nextStep();
        });
        wrapperInput.appendChild(btn);
      });

      setInput(wrapperInput);
    }

    // Étape 9 : objectif
    function stepObjectif() {
      showTyping(800, function() {
        addMessage("Quel est votre objectif principal pour vos cheveux en ce moment ?", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var options = [
        { value: "reparer", label: "Réparer et renforcer" },
        { value: "hydrater", label: "Hydrater et nourrir" },
        { value: "brillance", label: "Gagner en brillance" },
        { value: "discipline", label: "Discipliner / définir les boucles" },
        { value: "lisser", label: "Les lisser durablement" }
      ];

      options.forEach(function(opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'diag-btn';
        btn.textContent = opt.label;
        btn.addEventListener('click', function() {
          state.objectif = opt.value;
          addMessage(opt.label, 'user');
          nextStep();
        });
        wrapperInput.appendChild(btn);
      });

      setInput(wrapperInput);
    }

    // Étape 10 : routine
    function stepRoutine() {
      showTyping(800, function() {
        addMessage("Et à la maison, comment décririez-vous votre routine capillaire ?", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var options = [
        { value: "pro_regulier", label: "J’utilise des soins pro régulièrement" },
        { value: "pro_rarement", label: "J’utilise des soins pro de temps en temps" },
        { value: "simple", label: "Routine très simple, peu de soins" }
      ];

      options.forEach(function(opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'diag-btn';
        btn.textContent = opt.label;
        btn.addEventListener('click', function() {
          state.routine = opt.value;
          addMessage(opt.label, 'user');
          nextStep();
        });
        wrapperInput.appendChild(btn);
      });

      setInput(wrapperInput);
    }

    // Étape 11 : stress
    function stepStress() {
      showTyping(800, function() {
        addMessage("Et en ce moment, vous vous sentez plutôt stressée ou ça va ?", "bot");
      });

      var wrapperInput = document.createElement('div');
      wrapperInput.className = 'diag-input-row';

      var options = [
        { value: "oui", label: "Oui, je suis assez stressée" },
        { value: "non", label: "Non, ça va" }
      ];

      options.forEach(function(opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'diag-btn';
        btn.textContent = opt.label;
        btn.addEventListener('click', function() {
          state.stress = opt.value;
          addMessage(opt.label, 'user');
          nextStep();
        });
        wrapperInput.appendChild(btn);
      });

      setInput(wrapperInput);
    }

    // Helper pour prix exemple
    function formatEuro(n) {
      return n.toFixed(2).replace('.', ',') + " €";
    }

    // RÉSULTAT FINAL
    function showResult() {

      var prenomAffiche = state.prenom
        ? state.prenom.charAt(0).toUpperCase() + state.prenom.slice(1)
        : "Belle cliente";

      var prestations = [];
      var mainPresta = "";
      var secondPresta = "";
      var texteScenario = "";

      var estTextureBouclee =
        state.textureCheveux === "boucles" ||
        state.textureCheveux === "frises" ||
        state.textureCheveux === "afro";

      var lissagePossible =
        estTextureBouclee && state.envieTexture === "lisser_durablement";

      if (lissagePossible) {
        mainPresta = "lissage";
        if (state.abimes === "oui" || state.frequence === "moins1" || state.frequence === "1a3") {
          secondPresta = "profond";
        } else {
          secondPresta = "classique";
        }
        prestations = [mainPresta, secondPresta];

        var descTexture = "cheveux texturés";
        if (state.textureCheveux === "boucles") descTexture = "cheveux bouclés";
        if (state.textureCheveux === "frises") descTexture = "cheveux frisés";
        if (state.textureCheveux === "afro") descTexture = "cheveux afro";

        texteScenario =
          prenomAffiche + ", comme vous m’avez expliqué que vous ne souhaitez plus garder vos " + descTexture +
          " au naturel, je vous conseille en priorité un <strong>lissage</strong>. " +
          "Il va lisser durablement votre cheveu, discipliner la fibre et réduire le volume et les frisottis.<br><br>";

        if (secondPresta === "profond") {
          texteScenario +=
            "Pour que le lissage reste beau dans le temps, je vous recommande ensuite de programmer un <strong>soin profond</strong>. " +
            "Il viendra nourrir et renforcer vos longueurs pour garder un cheveu souple et brillant.";
        } else {
          texteScenario +=
            "Pour entretenir votre lissage au quotidien, vous pourrez ensuite faire un <strong>soin classique</strong> " +
            "régulièrement afin de garder douceur et brillance.";
        }

      } else {
        // Pas de lissage : on choisit entre soin profond / classique
        if (state.abimes === "oui") {
          mainPresta = "profond";
          secondPresta = "classique";
          prestations = [mainPresta, secondPresta];

          texteScenario =
            prenomAffiche + ", comme vos cheveux sont un peu sensibilisés et abîmés, je vous conseille en priorité un " +
            "<strong>soin profond</strong>. C’est le seul soin capable de vraiment réparer la fibre, nourrir et hydrater en profondeur " +
            "pour redonner force, souplesse et élasticité à vos cheveux.<br><br>" +
            "Une fois que vos cheveux seront bien remis en forme, on pourra ensuite passer sur un <strong>soin classique</strong> " +
            "tous les 3 mois environ pour entretenir la brillance et la douceur.";

        } else if (state.frequence === "moins1" || state.routine === "simple") {
          mainPresta = "profond";
          secondPresta = "classique";
          prestations = [mainPresta, secondPresta];

          texteScenario =
            prenomAffiche + ", comme vous ne venez pas très souvent au salon ou que votre routine est assez légère, " +
            "je vous recommande en priorité un <strong>soin profond</strong>. Il va donner un vrai coup de boost à vos cheveux, " +
            "en apportant une réparation et une hydratation durables (environ 2 à 3 mois de résultat).<br><br>" +
            "Ensuite, vous pourrez alterner avec un <strong>soin classique</strong> pour garder ce résultat sur la durée.";

        } else {
          mainPresta = "classique";
          secondPresta = "profond";
          prestations = [mainPresta, secondPresta];

          texteScenario =
            prenomAffiche + ", vos cheveux ne sont pas particulièrement abîmés et votre rythme au salon est plutôt régulier. " +
            "Je vous conseille donc en priorité un <strong>soin classique</strong> : c’est le soin d’entretien idéal pour garder " +
            "de la brillance, de la douceur et une belle matière au quotidien.<br><br>" +
            "De temps en temps, quand vous sentez que vos longueurs ont besoin d’un gros renfort, on pourra ajouter un " +
            "<strong>soin profond</strong> pour booster la réparation et la nutrition.";
        }
      }

      // Détails par prestation
      var detailsPrestationsTexte = "";

      if (prestations.indexOf("classique") !== -1) {
        detailsPrestationsTexte +=
          "<p><strong>Soin classique :</strong> c’est votre soin d’entretien. Au salon, nous avons une dizaine de soins classiques " +
          "(brillance, douceur, nutrition légère, éclat…). Une fois arrivée, votre coiffeuse réalisera un <strong>diagnostic capillaire personnalisé</strong> " +
          "avec vous, " + prenomAffiche + ", et choisira le soin classique le plus adapté à vos cheveux.</p>";
      }

      if (prestations.indexOf("profond") !== -1) {
        detailsPrestationsTexte +=
          "<p><strong>Soin profond :</strong> c’est notre soin intensif, conçu pour réparer, nourrir et hydrater en profondeur les cheveux secs, abîmés ou fragilisés. " +
          "Il agit au cœur de la fibre capillaire pour restaurer la force, la souplesse et l’élasticité. C’est le seul soin capable de réparer réellement la fibre " +
          "et de redonner une vraie vitalité à vos longueurs, avec des effets qui durent environ 2 à 3 mois.</p>" +
          "<p>Chez Grenadine, le soin profond est sublimé par l’utilisation du <strong>Spa Mist II</strong>, une technologie japonaise de soin à la vapeur. " +
          "Ses microbulles d’eau chaude ouvrent délicatement les écailles du cheveu pour permettre aux actifs de pénétrer en profondeur : résultat, un moment de détente absolu " +
          "et des cheveux réparés, hydratés et incroyablement doux au toucher. Nous disposons d’une dizaine de soins profonds différents, " +
          "sélectionnés avec vous sur place selon votre nature de cheveux et vos besoins spécifiques. Tous nos soins profonds sont au même prix, " +
          "pour plus de transparence et de liberté ✨</p>";
      }

      if (prestations.indexOf("lissage") !== -1) {
        detailsPrestationsTexte +=
          "<p><strong>Lissage :</strong> nous proposons plusieurs types de lissages au salon, en fonction de votre nature de cheveux et du résultat souhaité. " +
          "Le jour de votre rendez-vous, votre coiffeuse analysera vos longueurs avec vous, " + prenomAffiche +
          ", et vous orientera vers le <strong>lissage le plus adapté</strong> (respect du cheveu, tenue, rendu final).</p>";
      }

      // 1) Bloc soins recommandés
      var prestationsHtml =
        "<div class='diag-result-block'>" +
        "<h3>1 • Le soin le plus adapté pour vous</h3>" +
        "<p>" + texteScenario + "</p>" +
        detailsPrestationsTexte;

      // Rappel spécifique si la cliente vient peu
      if (state.frequence === "moins1" || state.frequence === "1a3") {
        prestationsHtml +=
          "<p>" + prenomAffiche + ", comme vous venez plutôt rarement au salon, je me permets de vous rappeler que le meilleur soin que vous puissiez offrir à vos cheveux " +
          "est tout simplement de <strong>couper vos pointes tous les 3&nbsp;mois</strong>. Cela évite que la casse remonte et permet de garder une chevelure nette et pleine de vitalité.</p>";
      }

      prestationsHtml +=
        "<p>De manière générale, nous conseillons de <strong>couper vos pointes tous les 3&nbsp;mois</strong>. " +
        "L’idéal est de venir chez le coiffeur environ <strong>4 fois par an</strong>.</p>" +
        "<p>" + prenomAffiche + ", vous pouvez dès maintenant réserver la prestation qui vous parle le plus. Le jour J, votre coiffeuse affinera tout ça avec vous en salon.</p>" +
        "<div class='diag-options'>";

      prestations.forEach(function(p) {
        if (p === "classique") {
          prestationsHtml +=
            "<a class='diag-cta' href='" + lienSoinClassique + "' target='_blank' rel='noopener'>Soin classique</a>";
        } else if (p === "profond") {
          prestationsHtml +=
            "<a class='diag-cta' href='" + lienSoinProfond + "' target='_blank' rel='noopener'>Soin profond</a>";
        } else if (p === "lissage") {
          prestationsHtml +=
            "<a class='diag-cta' href='" + lienLissage + "' target='_blank' rel='noopener'>Lissage</a>";
        }
      });

      prestationsHtml += "</div></div>";

      // 2) Bloc paiement en plusieurs fois (exemple selon la prestation principale)
      var exempleTitre = "";
      var exemple3 = "";
      var exemple4 = "";

      if (mainPresta === "profond") {
        var prixP = 150; // EXEMPLE
        exempleTitre = "Exemple pour un soin profond à " + formatEuro(prixP);
        exemple3 = formatEuro(prixP / 3) + " x 3";
        exemple4 = formatEuro(prixP / 4) + " x 4";
      } else if (mainPresta === "lissage") {
        var prixL = 250; // EXEMPLE
        exempleTitre = "Exemple pour un lissage à " + formatEuro(prixL);
        exemple3 = formatEuro(prixL / 3) + " x 3";
        exemple4 = formatEuro(prixL / 4) + " x 4";
      } else {
        var prixC = 70; // EXEMPLE soin classique
        exempleTitre = "Exemple pour un soin classique à " + formatEuro(prixC);
        exemple3 = formatEuro(prixC / 3) + " x 3";
        exemple4 = formatEuro(prixC / 4) + " x 4";
      }

      var paiementHtml =
        "<div class='diag-result-block'>" +
        "<h3>2 • Paiement en plusieurs fois</h3>" +
        "<div class='diag-payment-card'>" +
        "<div class='diag-payment-header'><span>GRN • Reçu</span><span>…</span></div>" +
        "<div class='diag-payment-row'><span>" + exempleTitre + "</span><span>&nbsp;</span></div>" +
        "<hr class='diag-separator'>" +
        "<div class='diag-payment-row diag-payment-row-strong'><span>Exemple 3x</span><span>" + exemple3 + "</span></div>" +
        "<div class='diag-payment-row diag-payment-row-strong'><span>Exemple 4x</span><span>" + exemple4 + "</span></div>" +
        "<p class='diag-payment-note'>Les montants indiqués sont donnés à titre d’exemple. Le montant exact de votre mensualité s’affichera au moment du paiement en ligne. " +
        "Vous pourrez régler en <strong>3 ou 4 fois</strong> avec <strong>Klarna</strong>, <strong>PayPal</strong> ou <strong>Alma</strong>, selon ce qui vous arrange le plus.</p>" +
        "</div>" +
        "</div>";

      // 3) Bloc suppléments
      var supplTexte =
        "<p>Au moment de votre réservation, vous pourrez ajouter un supplément pour personnaliser encore plus votre rendez-vous.</p>";

      if (state.stress === "oui") {
        supplTexte +=
          "<p>Comme vous m’avez indiqué être un peu stressée en ce moment, le <strong>massage crânien (20&nbsp;min)</strong> est parfait pour vous, " +
          prenomAffiche + " : il relâche les tensions, détend votre cuir chevelu et stimule la repousse.</p>";
      } else {
        supplTexte +=
          "<p>Si vous avez besoin de détente, pensez au <strong>massage crânien (20&nbsp;min)</strong> pour relâcher les tensions et booster la repousse.</p>";
      }

      var supplementsHtml =
        "<div class='diag-result-block'>" +
        "<h3>3 • Suppléments à ajouter</h3>" +
        supplTexte +
        "<div class='diag-supp-select'>" +
        "<div class='diag-supp-header'>SÉLECTIONNER VOTRE SUPPLÉMENT</div>" +
        "<div class='diag-supp-options'>" +
        "<div class='diag-supp-option'>Sans option</div>" +
        "<div class='diag-supp-option'>Gommage du cuir chevelu</div>" +
        "<div class='diag-supp-option'>Wavy</div>" +
        "<div class='diag-supp-option highlight'>Massage (20min)</div>" +
        "<div class='diag-supp-option'>Coupe fourches / pointes</div>" +
        "</div>" +
        "</div>" +
        "<p style='font-size:13px;margin-top:8px;'>Les suppléments se choisissent directement dans le menu déroulant lors de votre prise de rendez-vous.</p>" +
        "</div>";

      // 4) Bloc programme fidélité – image à droite
      var texteFreq = "";
      if (state.frequence === "plus3" || state.frequence === "1a3") {
        texteFreq = "Comme vous venez déjà au moins une fois par an, le programme devient très vite intéressant pour vous.";
      } else {
        texteFreq = "Même si vous ne venez pas encore souvent, le programme devient vite intéressant dès que vous prenez l’habitude de venir régulièrement.";
      }

      var fideliteHtml =
        "<div class='diag-result-block diag-programme'>" +
        "<div class='diag-programme-text'>" +
        "<div class='diag-programme-sub'>PROGRAMME DE FIDÉLITÉ</div>" +
        "<div class='diag-programme-title'>GRENADINE+</div>" +
        "<p><strong>Envie de réserver vos rendez-vous à prix réduit, " + prenomAffiche + " ?</strong> Le programme GRENADINE+ est fait pour vous.</p>" +
        "<p>" + texteFreq + "</p>" +
        "<p>Il vous permet de profiter de <strong>remises automatiques</strong> sur vos prestations, sans code à entrer : la remise s’applique directement dans votre panier.</p>" +
        "<p>Et surtout, il vous ouvre l’accès à des prestations <strong>exclusives membres</strong> :</p>" +
        "<div class='diag-pill'>Coupe pointes à 15&nbsp;€</div>" +
        "<div class='diag-pill'>Coupe frange à 12&nbsp;€</div>" +
        "<p style='margin-top:10px;'>Idéal pour respecter le rythme d’une <strong>coupe de pointes tous les 3&nbsp;mois</strong> sans exploser le budget.</p>" +
        "<div class='diag-options' style='margin-top:12px;'>" +
        "<a class='diag-cta' href='" + lienProgrammeFid + "' target='_blank' rel='noopener'>Découvrir le programme GRENADINE+</a>" +
        "</div>" +
        "</div>" +
        "<div class='diag-programme-img-wrap'>" +
        "<img src='https://cdn.shopify.com/s/files/1/0729/3983/1631/files/Design_sans_titre_5.png?v=1762082272' alt='Programme GRENADINE+'>" +
        "</div>" +
        "</div>";

      // 5) Bloc compte / connexion
      var blocCompte = "";
      if (state.dejaVenue === "premiere") {
        blocCompte =
          "<div class='diag-result-block'>" +
          "<h3>5 • Créer votre espace Grenadine</h3>" +
          "<p>Comme c’est votre première fois chez nous, " + prenomAffiche + ", je vous conseille de créer votre espace client. " +
          "Vous pourrez suivre vos rendez-vous, vos avantages et vos remises GRENADINE+.</p>" +
          "<div class='diag-options'>" +
          "<a class='diag-cta' href='" + lienRegister + "' target='_blank' rel='noopener'>Créer mon compte</a>" +
          "</div>" +
          "</div>";
      } else if (state.dejaVenue === "deja") {
        blocCompte =
          "<div class='diag-result-block'>" +
          "<h3>5 • Connexion à votre espace</h3>" +
          "<p>Pour finaliser votre réservation et retrouver vos informations, connectez-vous à votre espace Grenadine.</p>" +
          "<div class='diag-options'>" +
          "<a class='diag-cta' href='" + lienLogin + "' target='_blank' rel='noopener'>Me connecter</a>" +
          "</div>" +
          "</div>";
      } else {
        blocCompte =
          "<div class='diag-result-block'>" +
          "<h3>5 • Votre espace Grenadine</h3>" +
          "<div class='diag-options'>" +
          "<a class='diag-cta' href='" + lienRegister + "' target='_blank' rel='noopener'>Créer mon compte</a>" +
          "<a class='diag-cta' href='" + lienLogin + "' target='_blank' rel='noopener'>Me connecter</a>" +
          "</div>" +
          "</div>";
      }

      // 6) Bloc réassurance spécial boucles
      var curlyHtml = "";
      if (estTextureBouclee && state.envieTexture !== "lisser_durablement") {
        curlyHtml =
          "<div class='diag-result-block'>" +
          "<h3>Boucles & respect de vos envies</h3>" +
          "<p>Chez Grenadine, nous suivons vos envies, " + prenomAffiche + ". Si vous voulez garder vos boucles, on est là pour les <strong>sublimer</strong> : " +
          "on travaille la définition, l’hydratation et la brillance pour que votre texture naturelle soit la plus belle possible.</p>" +
          "<p>Et si un jour vous avez envie d’un <strong>brushing ponctuel</strong> pour un événement ou juste pour changer, " +
          "on le réalise avec plaisir, sans casser vos boucles d’origine et surtout sans vous faire culpabiliser. Vos boucles restent les bienvenues chez nous 🩷</p>" +
          "</div>";
      }

      // Photo du salon
      var photoHtml =
        "<div class='diag-result-block'>" +
        "<img src='https://cdn.shopify.com/s/files/1/0729/3983/1631/files/ChatGPT_Image_26_oct._2025_18_06_04.png?v=1761498728' " +
        "alt='Salon Grenadine' class='diag-result-image'>" +
        "</div>";

      var html = "";
      html += "<h2 class='diag-result-title'>" +
        prenomAffiche + ", voici la prestation la plus adaptée à vos cheveux 🩷</h2>";
      html += "<p class='diag-result-subtitle'>Vous retrouvez ci-dessous toutes les informations pour réserver sereinement.</p>";
      html += photoHtml;
      html += prestationsHtml;
      html += paiementHtml;
      html += supplementsHtml;
      html += fideliteHtml;
      html += blocCompte;
      html += curlyHtml;

      inputArea.innerHTML = '';
      var res = document.createElement('div');
      res.className = 'nana-result';
      res.innerHTML = html;
      chat.appendChild(res);
      res.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    steps = [
      stepPrenom,
      stepDejaVenue,
      stepDerniereFois,
      stepTypeCheveux,
      stepTextureCheveux,
      stepEnvieTexture,
      stepCheveuxAbimes,
      stepFrequence,
      stepObjectif,
      stepRoutine,
      stepStress
    ];

    // Prenom deja connu (cliente connectee) : on saute la question du prenom
    if (opts.prenom) {
      state.prenom = opts.prenom;
      steps.shift();
    }
    api.isTextStep = function () { return !!inputArea.querySelector('.diag-text-input'); };
    api.state = state;

    setTimeout(function() {
      if (opts.firstMessage) { addMessage(opts.firstMessage, 'user'); }
      showTyping(900, function() {
        addMessage((opts.prenom ? "Bonjour " + opts.prenom + " 🩷<br>" : "") +
          "On prend une petite minute ensemble pour analyser vos cheveux et choisir la bonne prestation 🌸", "bot");
        nextStep();
      });
    }, 250);

  }

  function open(opts) {
    opts = opts || {};
    var old = document.querySelector(".nana-modal");
    if (old) old.remove();
    var modal = buildModal();
    document.body.appendChild(modal);
    document.documentElement.classList.add("nana-lock");
    requestAnimationFrame(function () { modal.classList.add("is-open"); });

    var chat = modal.querySelector(".nana-chat");
    var options = modal.querySelector(".nana-options");
    var bar = modal.querySelector(".nana-bar");
    var input = modal.querySelector(".nana-input");
    var send = modal.querySelector(".nana-send");
    var mic = modal.querySelector(".nana-mic");
    var api = {};

    // les messages defilent dans le corps de la fenetre
    var body = modal.querySelector(".nana-body");
    new MutationObserver(function () { body.scrollTop = body.scrollHeight; }).observe(chat, { childList: true });
    new MutationObserver(function () { body.scrollTop = body.scrollHeight; }).observe(options, { childList: true });

    runDiagnostic({ chat: chat, options: options }, { firstMessage: opts.firstMessage ? esc(opts.firstMessage) : "", prenom: opts.prenom || "" }, api);

    function close() {
      modal.classList.remove("is-open");
      document.documentElement.classList.remove("nana-lock");
      setTimeout(function () { modal.remove(); }, 300);
    }
    modal.querySelector(".nana-close").addEventListener("click", close);
    function onKey(e) { if (e.key === "Escape") { document.removeEventListener("keydown", onKey); close(); } }
    document.addEventListener("keydown", onKey);

    input.addEventListener("input", function () { send.classList.toggle("is-ready", !!input.value.trim()); });

    // texte tape dans la barre du bas : sert de reponse a la question en cours
    function normalize(t) { return (t || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""); }
    function answer(text) {
      text = (text || "").trim();
      if (!text) return;
      var field = options.querySelector(".diag-text-input");
      if (field) {
        field.value = text;
        var ok = options.querySelector(".diag-btn");
        if (ok) ok.click();
      } else {
        var t = normalize(text);
        var best = null, bestScore = 0;
        options.querySelectorAll(".diag-btn").forEach(function (b) {
          var words = normalize(b.textContent).split(/[^a-z0-9]+/).filter(function (w) { return w.length > 2; });
          var score = words.filter(function (w) { return t.indexOf(w) !== -1; }).length;
          if (score > bestScore) { best = b; bestScore = score; }
        });
        if (best) {
          best.click();
        } else {
          var u = document.createElement("div");
          u.className = "diag-message diag-user"; u.textContent = text; chat.appendChild(u);
          var r = document.createElement("div");
          r.className = "diag-message diag-bot";
          r.innerHTML = options.querySelector(".diag-btn")
            ? "Je n'ai pas bien compris 🩷 Touchez une des réponses proposées juste au-dessus."
            : "Merci 🩷";
          chat.appendChild(r);
        }
      }
      input.value = "";
      send.classList.remove("is-ready");
    }
    bar.addEventListener("submit", function (e) { e.preventDefault(); answer(input.value); });

    var Speech = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!Speech) {
      mic.style.display = "none";
    } else {
      var rec = null;
      mic.addEventListener("click", function () {
        if (rec) { rec.stop(); return; }
        rec = new Speech();
        rec.lang = "fr-FR";
        rec.interimResults = true;
        rec.onresult = function (e) {
          var said = Array.prototype.map.call(e.results, function (r) { return r[0].transcript; }).join(" ");
          input.value = said;
          send.classList.add("is-ready");
          if (e.results[e.results.length - 1].isFinal) { answer(said); }
        };
        rec.onend = rec.onerror = function () { mic.classList.remove("is-listening"); rec = null; };
        mic.classList.add("is-listening");
        rec.start();
      });
    }
  }

  window.GrenadineNana = { open: open };
})();
